<template>
  <div>
    <table width="100%">
      <tr>
        <td width="20%">
          <img v-bind:src="institue.Logo" style="width: 100px; height: 100px;">
        </td>
        <td width="60%" style="text-align: center">
          <h3 style="margin-bottom: 0px;">
            {{institue.Name}}
          </h3>
          <h4 style="margin-top: 5px; margin-bottom: 0px;">
            JOB APPLICANTS SUMMARY
          </h4>
        </td>
        <td width="20%" style="text-align: right;">
          <div style="text-align: center; float:right"> 
          </div>
        </td>
      </tr>
      <tr>
        <td colspan="3"></td>
      </tr>
    </table>
    <table width="100%">
      <tbody>
        <tr>
          <td>
            <table border="1" width="100%" style="border-collapse: collapse; font-size: 12px">
              <tr>
                <th class="bg" align="left" width="20">City:</th>
                <td align="left" width="20">{{city}}</td>
                <th class="bg" align="left" width="15">Degree:</th>
                <td align="left" width="15">{{agg}}</td>
                <th class="bg" align="left" width="20">Job Offered:</th>
                <td align="left" width="20">{{job}}</td>
              </tr>
            </table>
            <table border="1" width="100%" style="border-collapse: collapse; font-size: 12px">
              <tr>
                <th class="bg" align="left" width="20">Date From:</th>
                <td align="left" width="20">{{from}}</td>
                <th class="bg" align="left" width="15">Date To:</th>
                <td align="left" width="15">{{to}}</td>
                <th class="bg" align="left" width="15">Application Status:</th>
                <td align="left" width="15">{{as}}</td>
              </tr>
            </table>
            <table border="1" width="100%" style="border-collapse: collapse; font-size: 12px">
              <tr>
                <th class="bg" align="left" width="20">Age From:</th>
                <td align="left" width="20">{{agefrom}}</td>
                <th class="bg" align="left" width="15">Age To:</th>
                <td align="left" width="15">{{ageto}}</td>
              </tr>
            </table>
            <table border="1" width="100%" style="border-collapse:collapse; font-size: 12px; margin-top:10px">
              <thead>
                <tr>
                  <th class="bg">Sr. No.</th>
                  <th class="bg">Job Title</th>
                  <th class="bg">No Of Applicants</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, ind) in data">
                  <td align="center">{{ind+1 }}</td>
                  <td>{{item.JobTitle}}</td>
                  <td align="center">{{item.JobTitles}}</td>
                </tr>
                <tr>
                  <th class="bg" colspan="2">Total Applicants</th>
                  <th class="bg">{{totalapplicants.toLocaleString()}}</th>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template> 
<script>
  const axios = require('axios').default;
  export default ({
    data() {
      return {
        data: [],
        sess: '', 
        totalapplicants: 0,
        city: '',
        agg: '',
        institue:[],
        gender: '',
        job: '',
        as: '', 
        agefrom: '',
        ageto: ''
      }
    },
    mounted: function () {
      this.pagePrint();
    },
    methods: {
      pagePrint() {
        var vm = this;
        axios.post('/JobApplicationsApi/pageLoadApplicantSummaryPrint')
          .then(function (res) {
            vm.data = res.data.lst;
            vm.sess = res.data.sess; 
            vm.totalapplicants = res.data.totalapplicants;

            vm.agg = res.data.agg;
            vm.city = res.data.city;
            vm.gender = res.data.gender;
            vm.job = res.data.job;
            vm.institue = res.data.institue;
            vm.as = res.data.ApplicationStatus;
            vm.agefrom = res.data.agefrom;
            vm.ageto = res.data.ageto;
          })
      }
    }
  })
</script>
<style>
  .bg {
    background-color: lightgrey;
  }
</style>



// WEBPACK FOOTER //
// src/components/jobApplicantSummaryPrint.vue